import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationDataService {
  private readonly usStates = [
    'AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
    'AS',
    'GU',
    'MP',
    'PR',
    'UM',
    'VI',
  ];

  private readonly caProvinces = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NT',
    'NS',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT',
  ];

  get statesFromUs(): string[] {
    return [...this.usStates];
  }

  get provincesFromCa(): string[] {
    return [...this.caProvinces];
  }

  getStatesByCountry(country: string): string[] {
    switch (country) {
      case 'Canada':
        return this.provincesFromCa;
      case 'USA':
      case 'UnitedStates':
      case 'United States':
      // case 'US':
        return this.statesFromUs;
      default:
        return [];
    }
  }
}
